export const adventureLogsIndex = {
  eyebrow: 'Adventure Logs',
  heading: 'Field notes from inside client builds.',
  tagline: 'Short-to-medium essays on the systems we ship, the regulatory shifts that shape them, and the operator decisions behind the code. New posts land when work is worth writing up, not on a fixed cadence.',
  backLinkLabel: 'Back to Adventure Logs',
  emptyState: 'No posts yet.',
};
